import { defineNuxtModule, addServerHandler, createResolver } from "@nuxt/kit";
import { defu } from "defu";
import type { RequestLogOptions } from "./types";

export default defineNuxtModule<RequestLogOptions>({
  meta: {
    name: "request-log-starter",
    configKey: "requestLog",
    compatibility: {
      nuxt: "^3.0.0",
    },
  },
  defaults: {
    enabled: true,
    logBody: false,
    logHeaders: false,
    format: "json",
    maskHeaders: ["authorization", "cookie"],
  },
  setup(options, nuxt) {
    const resolver = createResolver(import.meta.url);

    // Make options available in runtime config
    nuxt.options.runtimeConfig.public.requestLog = defu(nuxt.options.runtimeConfig.public.requestLog || {}, options);

    // Add middleware for request logging
    addServerHandler({
      handler: resolver.resolve("./runtime/middleware"),
      middleware: true,
    });

    // Setup context helper
    nuxt.hook("nitro:config", (nitroConfig) => {
      nitroConfig.externals = nitroConfig.externals || {};
      nitroConfig.externals.inline = nitroConfig.externals.inline || [];
      nitroConfig.externals.inline.push(resolver.resolve("./runtime"));

      // Add runtime context injections
      nitroConfig.runtimeConfig = nitroConfig.runtimeConfig || { app: {} };
      nitroConfig.runtimeConfig.app = nitroConfig.runtimeConfig.app || {};
      nitroConfig.runtimeConfig.app.requestLog = options;
    });

    // Register runtime config
    nuxt.hooks.hook("nitro:init", (nitro: any) => {
      // Set up Nitro options
      nitro.options.handlers = nitro.options.handlers || [];
      nitro.options.devHandlers = nitro.options.devHandlers || [];
      nitro.options.appConfig = nitro.options.appConfig || {};
      nitro.options.appConfig.requestLog = options;
    });
  },
});
